
import {Location} from "history"
import {undefinedToNull} from "./tsutil"
import {BookerFragFragment, LocaleFragment} from "./graphql/queries"

export function *parseQueryString(query: string): Iterable<[string, string]> {
  if (query[0] === "?") {
    query = query.substr(1);
  }
  for (const part of query.split("&")) {
    const [k, v] = part.split("=", 2);
    yield [
      decodeURIComponent(k),
      decodeURIComponent(v || ""),
    ];
  }
}

export function unparseQueryString(parts: Iterable<[string, string | undefined | null]>): string {
  let first = true;
  let query = "";
  for (const [k, v] of parts) {
    if (v == null) {
      continue;
    }
    query += (first ? "?" : "&") + encodeURIComponent(k) + "=" + encodeURIComponent(v);
    first = false;
  }
  return query;
}

const AustralianStatesToLocaleUUIDMap = new Map([
  ["vic", "00000000-0001-4000-8000-000000000000"],
  ["nsw", "00000000-0002-4000-8000-000000000000"],
  ["act", "00000000-0003-4000-8000-000000000000"],
  ["qld", "00000000-0004-4000-8000-000000000000"],
  ["sa", "00000000-0005-4000-8000-000000000000"],
  ["wa", "00000000-0006-4000-8000-000000000000"],
  ["tas", "00000000-0007-4000-8000-000000000000"],
  ["nt", "00000000-0008-4000-8000-000000000000"],
]);

export interface UrlLocaleIdProp {
  urlLocaleId: string | null
}

export function getUrlLocaleId(location: Location): string | null {
  const query = new Map(parseQueryString(location.search));
  const state = query.get("state");
  if (state === undefined) {
    return null;
  }
  const uuid = AustralianStatesToLocaleUUIDMap.get(state);
  return undefinedToNull(uuid);
}

export function resolveLocale(
  urlLocaleId: string | null,
  booker: BookerFragFragment | null,
  defaultLocale: LocaleFragment,
) {
  // If we have a booker and the locale was not specified in the URL, use the locale from the
  // booker. Otherwise use the one from the defaultLocale query (which will be the one in the URL
  // if specified).
  return booker && !urlLocaleId ? booker.defaultLocale : defaultLocale;
}




// WEBPACK FOOTER //
// ./src/urlLocale.ts